<template>
  <ul :class="classes">
    <li v-for="(item, i) in items" :key="i">
      <template v-if="item.key">
        <p v-if="!isSubYaml(item.value)">
          {{ item.key }}: <span :class="valueClass">{{ item.value }}</span>
        </p>
        <template v-else>
          <p>{{ item.key }}:</p>
          <yaml-representation v-model="item.value" :coloured="coloured"/>
        </template>
      </template>
      <template v-else-if="isSubYaml(item.value)">
        <yaml-representation v-model="item.value" :coloured="coloured"/>
      </template>
      <p v-else :class="valueClass">{{ item.value }}</p>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'YamlRepresentation',
    props: {
      value: {},
      coloured: { default: false }
    },
    computed: {
      isArray() {
        return this.value instanceof Array;
      },
      classes() {
        if (this.isArray) {
          return ['arrayEl'];
        } else {
          return [];
        }
      },
      valueClass() {
        if (this.coloured) {
          return ['value-coloured'];
        } else {
          return [];
        }
      },
      items() {
        if (this.isArray) {
          return this.value.map((value) => {
            return { value };
          });
        } else {
          return Object.keys(this.value)
            .map((key) => {
              return {
                key,
                value: this.value[key]
              };
            });
        }
      }
    },
    methods: {
      isSubYaml(item) {
        return item instanceof Array || item instanceof Object;
      }
    }
  };
</script>

<style lang="less" scoped>
  ul {
    list-style: none;
    margin-left: 0.5em;
    text-align: left;

    p {
      margin: 0;
    }

    &.arrayEl {
      list-style-type: '-';
      margin-left: 1em;

      > li > p {
        padding-left: 5px;
      }
    }
  }

  .value-coloured {
    color: #a74a3d;
  }
</style>
